import { Caption1 } from "../../styles/typography";
import { toast as reactToast } from "react-toastify";
import { ToastBody, ToastButton } from "./styled";
import { IToastProps } from "./types.d.ts";

const sharedConfig = {
  icon: false,
  closeButton: false,
  closeOnClick: true,
  autoClose: 8000,
};

/**
 *
 * @param {IToastProps} param
 */
const toast = ({
  message,
  type = "default",
  button,
  promise,
  toastId,
  callback,
  onSuccessClose,
  autoClose,
  closeButton,
  progress,
}) => {
  // use different react-toastify function depending on if the toast is for a promise or not
  if (promise) {
    reactToast.promise(promise.function, {
      //promise success state
      success: {
        render() {
          return (
            <ToastBody>
              <Caption1>{message}</Caption1>
              {button && (
                <ToastButton onButtonClick={button.click}>
                  {button.text}
                </ToastButton>
              )}
            </ToastBody>
          );
        },
        toastId,
        ...sharedConfig,
        autoClose: autoClose !== undefined ? autoClose : sharedConfig.autoClose,
        closeButton: closeButton ? closeButton : sharedConfig.closeButton,
        onClose: () => {
          if (onSuccessClose) {
            onSuccessClose();
          }
        },
      },
      //promise error state
      error: {
        toastId,
        render(error) {
          return (
            <ToastBody>
              <Caption1>{promise.error.message}</Caption1>
              {promise.error.button && (
                <ToastButton onButtonClick={promise.error.button?.click}>
                  {promise.error.button?.text}
                </ToastButton>
              )}
            </ToastBody>
          );
        },
        ...sharedConfig,
        autoClose: autoClose !== undefined ? autoClose : sharedConfig.autoClose,
        closeButton: closeButton ? closeButton : sharedConfig.closeButton,
      },
      //promise loading state, defaults to Loading...
      pending: {
        render() {
          return (
            <ToastBody>
              <Caption1>{promise.pending?.message ?? "Loading..."}</Caption1>
            </ToastBody>
          );
        },
        toastId,
        ...sharedConfig,
        autoClose: autoClose !== undefined ? autoClose : sharedConfig.autoClose,
        closeButton: closeButton ? closeButton : sharedConfig.closeButton,
        icon: true,
      },
    });
  } else {
    reactToast(
      <ToastBody>
        <Caption1>{message}</Caption1>
        {button && (
          <ToastButton onButtonClick={button.click}>{button.text}</ToastButton>
        )}
      </ToastBody>,
      {
        toastId,
        ...sharedConfig,
        autoClose: autoClose !== undefined ? autoClose : sharedConfig.autoClose,
        closeButton: closeButton ? closeButton : sharedConfig.closeButton,
        type,
        onClose: () => {
          callback && callback();
        },
        pauseOnHover: false,
        progress,
      },
    );
  }
};

export default toast;
